<!--
 * @Description: 
 * @Author: xiawenlong
 * @Date: 2022-11-15 11:15:13
 * @LastEditors: xiawenlong
 * @LastEditTime: 2022-11-17 19:39:10
-->
<template>
  <div class="multiple-question">
    <el-form
      ref="multipleForm"
      :model="questionInfo"
      :rules="rules"
      label-width="70px"
      class="multipleForm"
    >
      <el-form-item label="题干:" prop="questionName">
        <tinymce
          ref="editor"
          v-model="questionInfo.questionName"
          height="170"
          width="812"
        ></tinymce>
      </el-form-item>
      <el-form-item label="选项:" prop="rightOptionId">
        <el-button
          v-show="questionInfo.optionList.length < tagList.length"
          class="addBtn"
          icon="el-icon-circle-plus-outline"
          @click="addOption"
        >
          增加选项
        </el-button>
        <el-checkbox-group v-model="questionInfo.rightOptionId">
          <div class="option-list">
            <div
              v-for="(item, index) in questionInfo.optionList"
              :key="item.id"
              class="option-item"
            >
              <el-checkbox :label="item.id">
                <div class="tag">{{ tagList[index].toUpperCase() }}</div>
              </el-checkbox>
              <tinymce ref="editor" v-model="item.optionName" height="120" width="739"></tinymce>
              <i
                v-show="questionInfo.optionList.length > 1"
                class="el-icon-delete"
                @click="removeOption(index)"
              ></i>
            </div>
          </div>
        </el-checkbox-group>
      </el-form-item>
    </el-form>
    <div class="footer">
      <el-button :loading="saveLoading" type="primary" @click="save">保存</el-button>
      <el-button @click="remove">删除</el-button>
    </div>
  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce'
let newOptionId = 1
export default {
  name: 'JudgeQuestion',
  components: { Tinymce },
  props: {
    questionInfo: {
      type: Object,
      default: () => ({
        optionList: [],
      }),
    },
    saveLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tagList: ['a', 'b', 'c', 'd', 'e', 'f', 'g'],
      rules: {
        questionName: [{ required: true, message: '请输入题干', trigger: 'blur' }],
        rightOptionId: [{ required: true, message: '请选择选项', trigger: 'change' }],
      },
    }
  },
  methods: {
    addOption() {
      if (this.questionInfo.optionList.length >= this.tagList.length) return
      this.questionInfo.optionList.push({
        id: 'new' + newOptionId,
        optionName: '',
      })
      newOptionId++
      console.log(this.questionInfo)
    },
    removeOption(index) {
      this.questionInfo.optionList.splice(index, 1)
    },
    save() {
      const { questionName, questionType, score, optionList, rightOptionId } = this.questionInfo
      let optionObj = {}
      let rightKeyArr = []
      optionList.map((item, index) => {
        console.log(rightOptionId.find(id => item.id == id))
        if (rightOptionId.find(id => item.id == id)) {
          rightKeyArr.push(index + 1)
        }
        this.$set(optionObj, this.tagList[index], item.optionName)
      })
      let params = {
        questionName,
        questionType,
        score,
        ...optionObj,
        rightKey: rightKeyArr.join(','),
      }
      this.$emit('edit', params)
    },
    remove() {
      this.$emit('remove')
    },
  },
}
</script>
<style lang="scss" scoped>
/deep/.el-form {
  .tox-tinymce {
    width: 820px;
  }
  .el-form-item__label {
    height: 36px;
    line-height: 36px;
  }
  .addBtn {
    width: 100px;
    height: 36px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    i {
      font-size: 16px;
    }
  }
  .option-item {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    .el-checkbox {
      display: flex;
      align-items: center;
      margin-right: 0;
      .el-checkbox__label {
        display: flex;
        align-items: center;
        padding-left: 20px;
      }
      &.is-checked {
        .el-checkbox__label {
          .tag {
            background-color: #3671bf;
          }
        }
      }
      .tag {
        border-radius: 50%;
        width: 28px;
        height: 28px;
        background: #c1c8d1;
        color: #fff;
        text-align: center;
        line-height: 28px;
        margin-right: 10px;
      }
    }
    > i {
      cursor: pointer;
      font-size: 16px;
      color: #3671bf;
      margin-left: 20px;
    }
  }
}
</style>
